"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findOptionMatchingValue = (valueToMatch, options, fallackOption = null) => {
    return valueToMatch
        ? options.find(opt => opt.value === valueToMatch)
        : fallackOption;
};
//# sourceMappingURL=findOptionMatchingValue.js.map